
<div class="event-wrap" (click)="showDetail(eventResult); $event.stopPropagation();" [class.expanded]="eventResult.isExpanded">

    <div class="row event-info">
        <div class="name-wrap">
            <!-- <div class="super-bet" *ngIf="eventResult.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</div>
            <div class="event-of-day" *ngIf="eventResult.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</div> -->
            <div class="name">{{eventResult.eventName}}</div>
        </div>
        <div class="date-time"><!--{{eventResult.eventDate}}--> {{eventResult.eventTime}}</div>
    </div>

    <article class="row" *ngIf="!eventResult.isExpanded">
        <div class="bet-type-wrap">
            <div class="bet-type-col">
                <ng-container *ngFor="let scoreGroup of scoreGroups; let i = index">
                    <div class="outcome-wrap">
                        <ng-container *ngIf="eventResult.results[scoreGroup.id]; let eventResults">
                            <ng-container *ngFor="let scorePeriod of eventResults.scorePeriods; let j = index;">
                                <span class="result-box">
                                    <ng-container *ngIf="eventResults.hasHomeAway; else singleScore">
                                        <span>{{scorePeriod.homeAwayValue[enumsHomeAway.HOME]}}</span>
                                        <span>{{scorePeriod.homeAwayValue[enumsHomeAway.AWAY]}}</span>
                                    </ng-container>
                                    <ng-template #singleScore>
                                        <span>{{scorePeriod.homeAwayValue[enumsHomeAway.NONE]}}</span>
                                    </ng-template>
                                </span>
                            </ng-container>
                        </ng-container>
                    </div>

                </ng-container>
            </div>

        </div>

        <div class="expand-event">+</div>

    </article>
</div>
